import type { IComplianceTableConfig } from '@/types/contracts';

const ROWS_TO_DISPLAY_ON_MOBILE = 1;
const ROWS_TO_DISPLAY_ON_DESKTOP = 6;

const COMPLIANCE_CONFIG_TABLE: IComplianceTableConfig = {
  week: { width: '15%', colorOne: '#e0f2fe', colorTwo: '#f0f9ff', colorText: '#075985' },
  requirements: { width: 'fit-content', colorOne: '#d1fae5', colorTwo: '#ecfdf5', colorText: '#047857' },
  nowShows: { width: '6%', colorOne: '#f3f4f6', colorTwo: '#f9fafb', colorText: '#374151' },
  lateIn: { width: '10%', colorOne: '#f3f4f6', colorTwo: '#f9fafb', colorText: '#374151' },
  earlyOff: { width: '10%', colorOne: '#f3f4f6', colorTwo: '#f9fafb', colorText: '#374151' },
  reason: { width: '25%', colorOne: '#f3f4f6', colorTwo: '#f9fafb', colorText: '#5a5a5a' },
};

export { ROWS_TO_DISPLAY_ON_MOBILE, ROWS_TO_DISPLAY_ON_DESKTOP, COMPLIANCE_CONFIG_TABLE };
